import { useSectionNav } from "../../lib/useSectionNav";
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import Logo from "./Logo";
import { MapPin, Phone, Mail } from "lucide-react";

const NAV = [
  { label: "Tjenester", href: "#tjenester" },
  { label: "Priser", href: "#priser" },
  { label: "Butikk", href: "/butikk" },
  { label: "Selg enheten din", href: "#selg" },
  { label: "Om oss", href: "#om-oss" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Footer({ onOpenLegal }) {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/content/contact").then((r) => setC(r.data || {})).catch(() => {}); }, []);
  const go = useSectionNav();

  return (
    <footer className="bg-navy text-slate-300" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
              Lokalt verksted i Oslo for reparasjon av mobil, nettbrett, Mac og PC – samt kjøp
              og innbytte av brukt elektronikk.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Navigasjon</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} onClick={(e) => { e.preventDefault(); go(n.href); }} className="text-sm text-slate-400 hover:text-warm transition-colors">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Kontakt</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              {c.address && <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-electric" /> {c.address}</li>}
              {c.phone && <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-electric" /> <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="hover:text-warm">{c.phone}</a></li>}
              {c.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-electric" /> <a href={`mailto:${c.email}`} className="hover:text-warm">{c.email}</a></li>}
              {!c.address && !c.phone && !c.email && <li className="text-slate-500">Kontaktinfo kommer snart.</li>}
            </ul>
            <div className="mt-4 flex flex-wrap gap-3 text-sm">
              {c.instagram && <a href={c.instagram} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-warm">Instagram</a>}
              {c.tiktok && <a href={c.tiktok} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-warm">TikTok</a>}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-white">Juridisk</h4>
            <ul className="mt-4 space-y-2.5">
              <li><button onClick={() => onOpenLegal("personvern")} className="text-sm text-slate-400 hover:text-warm" data-testid="footer-privacy">Personvern</button></li>
              <li><button onClick={() => onOpenLegal("cookies")} className="text-sm text-slate-400 hover:text-warm" data-testid="footer-cookies">Informasjonskapsler</button></li>
              <li><button onClick={() => onOpenLegal("vilkar")} className="text-sm text-slate-400 hover:text-warm" data-testid="footer-terms">Vilkår og betingelser</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} MobilHub{c.org_number ? ` · Org.nr ${c.org_number}` : ""}. Alle rettigheter forbeholdt.</p>
          <a href="/admin/login" className="text-xs text-slate-500 hover:text-slate-300" data-testid="footer-admin-link">Eierinnlogging</a>
        </div>
      </div>
    </footer>
  );
}
